// ignore-string-localization
import React from 'react';
import styled from 'styled-components';
import { screenSmMin } from '@spotify-internal/encore-foundation';
import { jsx as _jsx } from "react/jsx-runtime";
var MainWrapper = styled.main.withConfig({
  displayName: "Main__MainWrapper",
  componentId: "sc-1yplxwe-0"
})(["flex:1;display:flex;"]);
var MainContainer = styled.div.withConfig({
  displayName: "Main__MainContainer",
  componentId: "sc-1yplxwe-1"
})(["@media (min-width:", "){margin-left:auto;margin-right:auto;width:100%;}flex:1;max-width:100%;"], screenSmMin);
export var Main = function Main(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(MainWrapper, {
    children: /*#__PURE__*/_jsx(MainContainer, {
      children: children
    })
  });
};